/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention" 
import Floats from "../section/floats/Floats"
import useComponentData from "src/modules/pe-landing-module/hooks/useComponentData"
import { ILandingCanvas } from "src/modules/pe-landing-module/data/interfaces"

export interface ICanvasProps {  
    data: ILandingCanvas
}
/* Protopia Ecosystem component */ 
const Canvas = ({  ...props}: ICanvasProps): JSX.Element => { 
    const data: ILandingCanvas  = useComponentData<ILandingCanvas>(( props.data || {dimentions: {}} ) as ILandingCanvas )     
    const [height, ]            = useState<string>(getCssDemention( data?.height, "fit-content" ))
    useEffect(() => {
        addCSSClass(
            `canvas-${data.id}`,
            `.canvas-${data.id} { 
                height: ${ height };
                z-index:1;
            } 
            `
        ) 
        return () => {
            removeCSSClass(`canvas-${ data.id}`)
        }
    },[ data ])  
    
    return <div 
        role="article" 
        className={` landing-canvas canvas-${ data.id }`}
        style={ data.data?.style }
    >
        <Floats floats={ data.floats || []  } animated={data.animated} animated_delay={data.animated_delay} isCanvas />
    </div>
}
export default Canvas